import { render, staticRenderFns } from "./answerVolume.vue?vue&type=template&id=7c70d55c&scoped=true&"
import script from "./answerVolume.vue?vue&type=script&lang=js&"
export * from "./answerVolume.vue?vue&type=script&lang=js&"
import style0 from "./answerVolume.vue?vue&type=style&index=0&id=7c70d55c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70d55c",
  null
  
)

export default component.exports